export const DS_projects = [
  {
    title: "Advanced Retail Analytics using Excel and Python",
    description: "This project analyzes key performance indicators (KPIs) across sales, marketing, product, and customer.",
    imgUrl: "https://github.com/abdullah-khaled0/Advanced-Retail-Analytics-using-Excel-and-Python/raw/main/Customer_KPIs.png",
    linkUrl: "https://github.com/abdullah-khaled0/Advanced-Retail-Analytics-using-Excel-and-Python",
    tags: ["Excel", "Python", "Data Analysis", "KPIs"]
  },
  {
    title: "Customer Segmentation",
    description: "Segmented customers based on demographic, income, spending, and behavior data to enhance marketing personalization. Used clustering techniques like K-means and hierarchical methods.",
    imgUrl: "https://images.shiksha.com/mediadata/ugcDocuments/images/wordpressImages/2022_06_CUSTOMER-SEGMENTATION-1.jpg",
    linkUrl: "https://www.kaggle.com/code/abdullah7aled/customer-segmentation",
    tags: ["K-Means", "Clustering", "Python", "Kaggle"]
  },
  {
    title: "Stock Price Forecasting",
    description: "Developed a time series model using Facebook's Prophet library to predict stock prices. Built an interactive Streamlit app for real-time analysis and forecasting.",
    imgUrl: "https://tradebrains.in/features/wp-content/uploads/2021/07/stock-market-news-trade-brains.jpg",
    linkUrl: "https://github.com/abdullah-khaled0/ts-forecasting-with-prophet",
    tags: ["Prophet", "Time Series", "Streamlit", "Python"]
  },
  {
    title: "Customer Segmentation (LinkedIn)",
    description: "Segmented customers based on demographic, income, spending, and behavior data to enhance marketing personalization.",
    imgUrl: "https://www.bounteous.com/sites/default/files/insights/2022-10/previews/screen_shot_2022-09-01_at_12.34.57_pm.png",
    linkUrl: "https://www.linkedin.com/posts/abdullah-khaled-0608a9236_customer-segmentation-activity-7223320825699946497-K2ex/?utm_source=share&utm_medium=member_desktop",
    tags: ["Customer Segmentation", "Marketing", "Clustering"]
  },
  {
    title: "Customer Segmentation based on RFM",
    description: "The primary objective was to segment customers using RFM (Recency, Frequency, and Monetary) analysis, enabling more personalized and efficient marketing strategies.",
    imgUrl: "https://github.com/abdullah0150/Images/raw/main/images/project-2.png",
    linkUrl: "https://www.linkedin.com/posts/abdullah-khaled-0608a9236_customer-segmentation-based-on-rfm-activity-7240047977279434753-ybdZ?utm_source=share&utm_medium=member_desktop",
    tags: ["RFM Analysis", "Marketing Strategy", "SQL", "Python"]
  },
  {
    title: "Credit Fraud Detector",
    description: "The Credit Fraud Detector is a machine learning project designed to accurately detect fraudulent transactions. Using various predictive models, we aim to determine whether a transaction is a normal payment or fraudulent.",
    imgUrl: "https://camo.githubusercontent.com/03ea8e88edafd5ba5f47d9aa413375ea9d5a856f26e3e04e078898ad7b0d0a9b/68747470733a2f2f7777772e746563686f70656469612e636f6d2f77702d636f6e74656e742f75706c6f6164732f323032342f30362f36302d476c6f62616c2d4372656469742d436172642d46726175642d537461746973746963732d696e2d323032342e77656270",
    linkUrl: "https://github.com/abdullah-khaled0/Credit-Fraud-Detector",
    tags: ["Classification", "Machine Learning", "Imbalanced Data", "Python"]
  },
  {
    title: "Bank Marketing Campaign",
    description: "Identified segments more likely to open deposit accounts and analyzed communication channels for better conversion rates. Evaluated promotional strategies using past campaign data.",
    imgUrl: "https://camo.githubusercontent.com/f457d050545f58eb4649cc2940a9a0ebd015c58ba33b9675d97e83eb3c8d8473/68747470733a2f2f696d616765732e6374666173736574732e6e65742f39626d7373316a63766a39752f32585446743744795648655651336c79416875466d492f38363161333261623963333863376166623232316362313131363365323734642f436173682d6465706f736974732e706e67",
    linkUrl: "https://github.com/abdullah-khaled0/BankMarketingCampaign-OpeningATermDeposit",
    tags: ["Marketing Analytics", "Predictive Modeling", "Classification"]
  },
  {
    title: "Advanced House Price Prediction",
    description: "This project delves into advanced regression techniques to uncover the most impactful features affecting house prices, providing insights that go beyond mere predictions.",
    imgUrl: "https://miro.medium.com/v2/resize:fit:1024/1*Juv1bpp5--0Fl8cA4EmTPw.jpeg",
    linkUrl: "https://github.com/abdullah-khaled0/Advanced-House-Price-Prediction-and-EDA",
    tags: ["Regression", "Feature Engineering", "Python", "XGBoost"]
  },
  {
    title: "Is the Housing Market Heating in Melbourne?",
    description: "In this project, we will analyze house prices in Melbourne, Australia, to answer critical questions about the city's housing market. The goal is to provide insights into the current trends.",
    imgUrl: "https://camo.githubusercontent.com/13c1785fd011c6fd1730c6f54f98c142db14130bd58ba872e56568b76fa2f547/68747470733a2f2f6d656469612e6e6f6d616469636d6174742e636f6d2f323032342f6d656c627468696e67732e6a706567",
    linkUrl: "https://github.com/abdullah-khaled0/Melbourne-Australia-Housing-Market-Analysis-and-Predicting",
    tags: ["Housing Market", "EDA", "Data Visualization", "R"]
  },
  {
    title: "Movie Recommendation System",
    description: "Developed a recommendation system using the MovieLens 100k dataset and Collaborative-Filtering techniques.",
    imgUrl: "https://github.com/abdullah0150/Images/raw/main/images/project-4.png",
    linkUrl: "https://github.com/abdullah-khaled0/Movie-Recommendation-System-with-Collaborative-Filtering/blob/main/Movie%20Recommendation%20System%20with%20Collaborative%20Filtering%20Presentation.pdf",
    tags: ["Recommendation System", "Collaborative Filtering", "Python"]
  },
  {
    title: "A/B Testing Cookie Cats",
    description: "Conducted A/B testing on retention rates in the Cookie Cats mobile game when the gate was moved from level 30 to 40.",
    imgUrl: "https://github.com/abdullah0150/Images/raw/main/images/project-1.png",
    linkUrl: "https://github.com/abdullah-khaled0/Credit-Fraud-Detector",
    tags: ["A/B Testing", "Hypothesis Testing", "Bootstrap", "Statistics"]
  }
];

export const DA_projects = [
  {
    title: "Customer Churn Analysis",
    description: "The primary goal of this project was to analyze customer behavior and identify key drivers of churn. By understanding patterns in the data, actionable insights were derived to improve customer retention.",
    imgUrl: "https://github.com/abdullah-khaled0/Analyzing-Customer-Churn/raw/main/Dashboard.png",
    linkUrl: "https://github.com/abdullah-khaled0/Analyzing-Customer-Churn",
    tags: ["Power BI", "Churn Analysis", "EDA", "Insights"]
  },
  {
    title: "Sales Performance Enhancement",
    description: "Analyzed sales data to achieve $23.80M total sales (+39% YoY) and $21.94M profit (+39% YoY). Highlighted top-performing channels, categories, and promotional strategies.",
    imgUrl: "https://github.com/abdullah0150/Images/raw/main/images/project-5.png",
    linkUrl: "https://github.com/abdullah-khaled0/Sales-Dashboard-in-PowerBI/blob/main/presentation.pdf",
    tags: ["Sales Dashboard", "Power BI", "YoY Metrics", "KPIs"]
  },
  {
    title: "SSIS ETL Project",
    description: "Implemented an ETL process using SSIS and presented processed data using Power BI dashboards for insightful decision-making.",
    imgUrl: "https://github.com/abdullah0150/Images/blob/main/images/etl_img.png?raw=true",
    linkUrl: "https://example.com/etl-project",
    tags: ["SSIS", "ETL", "SQL Server", "Power BI"]
  },
  {
    title: "Walmart Sales Forecasting",
    description: "The objective is to build a robust predictive model that can accurately forecast weekly retail sales based on historical data and external indicators.",
    imgUrl: "https://github.com/abdullah-khaled0/Walmart-Analytics/raw/main/dashboard.png",
    linkUrl: "https://github.com/abdullah-khaled0/Walmart-Analytics",
    tags: ["Time Series", "Forecasting", "Python", "Analytics"]
  },
  {
    title: "Supply Chain Analysis in R",
    description: "This project provides an analysis of DataCo Global's supply chain data, covering Provisioning, Production, Sales, and Commercial Distribution.",
    imgUrl: "https://camo.githubusercontent.com/ab05c471d85c69a386b59efc41c47018cf5474cb7e2a93a57efcbcdab3a5202d/68747470733a2f2f706e672e706e67747265652e636f6d2f7468756d625f6261636b2f66773830302f6261636b67726f756e642f32303233303732322f706e67747265652e636f6d2f7468756d625f6261636b2f66773830302f6261636b67726f756e642f32303233303732322f706e67747265652d667574757269737469632d6175746f6d6f62696c65732d616e642d696c6c7573747261746f722d64657369676e2d696d6167655f333836383838382e6a7067",
    linkUrl: "https://github.com/abdullah-khaled0/Supply-Chain-Analysis-using-R",
    tags: ["Supply Chain", "R Language", "Optimization", "ggplot2"]
  },
  {
    title: "Customer Personality Analysis",
    description: "Clustered customer profiles to understand client segments and behaviors using unsupervised machine learning.",
    imgUrl: "https://github.com/Heba-A-Saleh/images1/raw/main/lv_0_20230317181948.gif",
    linkUrl: "https://www.kaggle.com/code/abdullah7aled/customer-personality-analysis-in-python",
    tags: ["Kaggle", "Clustering", "Python", "Seaborn"]
  },
  {
    title: "Pizza Sales Analytics",
    description: "Analyzed pizza sales metrics using SQL queries and visualised key trends in Power BI dashboards.",
    imgUrl: "https://github.com/abdullah-khaled0/Pizza-Sales-using-SQL-and-Power-BI/raw/main/Dash1.png",
    linkUrl: "https://github.com/abdullah-khaled0/Pizza-Sales-using-SQL-and-Power-BI",
    tags: ["SQL", "Power BI", "Data Wrangling", "Dashboards"]
  },
  {
    title: "HR Analytics Dashboard",
    description: "Designed a comprehensive Power BI dashboard for human resources analytics, tracking employee retention and hiring metrics.",
    imgUrl: "https://github.com/abdullah-khaled0/My-Projects/blob/main/Data%20Analytics%20Projects/Power%20BI%20Projects/HR%20Analytics/display%201.png?raw=true",
    linkUrl: "https://github.com/abdullah-khaled0/My-Projects/tree/main/Data%20Analytics%20Projects/Power%20BI%20Projects/HR%20Analytics",
    tags: ["HR Analytics", "Power BI", "KPIs"]
  },
  {
    title: "Master Customer Dashboard",
    description: "Created a unified Power BI customer dashboard mapping key purchase patterns and sales channels.",
    imgUrl: "https://github.com/abdullah-khaled0/My-Projects/blob/main/Data%20Analytics%20Projects/Power%20BI%20Projects/Master%20Customer/display.png?raw=true",
    linkUrl: "https://github.com/abdullah-khaled0/My-Projects/tree/main/Data%20Analytics%20Projects/Power%20BI%20Projects/Master%20Customer",
    tags: ["Power BI", "Customer Insights"]
  },
  {
    title: "Data Professional Survey Breakdown",
    description: "Visualized and analyzed survey feedback from data industry professionals to extract salary and tool preference trends.",
    imgUrl: "https://github.com/abdullah-khaled0/My-Projects/blob/main/Data%20Analytics%20Projects/Power%20BI%20Projects/Data%20Professional%20Survey%20Breakdown/display.png?raw=true",
    linkUrl: "https://github.com/abdullah-khaled0/My-Projects/tree/main/Data%20Analytics%20Projects/Power%20BI%20Projects/Data%20Professional%20Survey%20Breakdown",
    tags: ["Power BI", "Survey Analysis"]
  },
  {
    title: "Store Sales Dashboard",
    description: "Built a sales tracking application in Power BI summarizing daily and monthly supermarket performance.",
    imgUrl: "https://github.com/abdullah-khaled0/My-Projects/blob/main/Data%20Analytics%20Projects/Power%20BI%20Projects/Store%20Sales/store%20sales.png?raw=true",
    linkUrl: "https://github.com/abdullah-khaled0/My-Projects/tree/main/Data%20Analytics%20Projects/Power%20BI%20Projects/Store%20Sales",
    tags: ["Power BI", "Sales Operations"]
  },
  {
    title: "Supermarket Sales Analytics",
    description: "Detailed dashboard charting supermarket product categories, store performance, and buyer behaviors.",
    imgUrl: "https://github.com/abdullah-khaled0/My-Projects/blob/main/Data%20Analytics%20Projects/Power%20BI%20Projects/Supermarket%20Sales/display%201.png?raw=true",
    linkUrl: "https://github.com/abdullah-khaled0/My-Projects/tree/main/Data%20Analytics%20Projects/Power%20BI%20Projects/Supermarket%20Sales",
    tags: ["Power BI", "Retail Analytics"]
  },
  {
    title: "Bike Sales Performance",
    description: "Excel-based analytical report and interactive dashboard representing global bike shop transactions.",
    imgUrl: "https://github.com/abdullah-khaled0/My-Projects/blob/main/Data%20Analytics%20Projects/Excel%20Projects/display.png?raw=true",
    linkUrl: "https://github.com/abdullah-khaled0/My-Projects/tree/main/Data%20Analytics%20Projects/Excel%20Projects",
    tags: ["Excel", "Dashboards", "Pivot Tables"]
  }
];

export const AI_SE_projects = [
  {
    title: "Hotels AI Agent",
    description: "A Flask-based web application leveraging CrewAI-powered AI agents to optimize hotel operations, including room reservations, guest management, and hotel details tracking.",
    imgUrl: "https://camo.githubusercontent.com/f69c989e9406aaa97dbd5767eae89ba5906d9631ae65d8f477639f83bdd23bca/68747470733a2f2f6b6e6f776d61782d61692d776562736974652e73332e616d617a6f6e6177732e636f6d2f77702d636f6e74656e742f75706c6f6164732f323032322f30312f31343132313035352f6b6e6f776c656467652d6d616e6167656d656e742d666f722d63686174626f742d66756e6374696f6e696e672d312e706e67",
    linkUrl: "https://www.linkedin.com/posts/abdullah-khaled-0608a9236_%D8%B9%D9%85%D9%84%D8%AA-ai-agent-%D8%AA%D9%82%D8%AF%D8%B1-%D8%AA%D8%AF%D8%B1%D8%AF%D8%B4-%D9%85%D8%B9%D8%A7%D9%87-%D9%83-chatbot-%D9%88%D8%A7%D9%84%D9%81%D9%83%D8%B1%D8%A9-activity-7304849359987208192--g0b?utm_source=share&utm_medium=member_desktop&rcm=ACoAADrdZwgBeRZJui8GXBIdXTsTid0ZnVsQCT0",
    tags: ["CrewAI", "Flask", "AI Agents", "Python"]
  },
  {
    title: "AI-Powered Search & Recs",
    description: "A FastAPI-powered application that generates Firestore query expressions based on user input using LangChain and Google Gemini AI.",
    imgUrl: "https://github.com/abdullah-khaled0/AI-Powered-Search-and-Recommendation-System/raw/main/demo.gif",
    linkUrl: "https://www.linkedin.com/posts/abdullah-khaled-0608a9236_ai-fastapi-flutter-activity-7293641319397122048-jmWt?utm_source=share&utm_medium=member_desktop&rcm=ACoAADrdZwgBeRZJui8GXBIdXTsTid0ZnVsQCT0",
    tags: ["FastAPI", "LangChain", "Gemini AI", "Firestore", "Flutter"]
  },
  {
    title: "Llama 3.2 SQL Agent",
    description: "This project provides an interactive Streamlit application that uses LangChain, LangGraph, and Ollama's Llama 3.2 to generate and execute SQL queries based on user input.",
    imgUrl: "https://github.com/abdullah-khaled0/SQL-Agent-with-Llama3.2.3B-Model/raw/main/sql_agent.gif",
    linkUrl: "https://github.com/abdullah-khaled0/SQL-Agent-with-Llama3.2.3B-Model",
    tags: ["LangGraph", "Llama 3.2", "SQL Agent", "Streamlit", "Ollama"]
  },
  {
    title: "FastAPI Chatbot with Gemini",
    description: "A robust FastAPI application leveraging LangChain, Google Generative AI, and FAISS for document-based question answering. Integrated with Flutter.",
    imgUrl: "https://github.com/abdullah-khaled0/chatbot-with-Gemini-Railway/raw/main/demo_gif.gif",
    linkUrl: "https://www.linkedin.com/posts/doaa-safwat-794b72289_flutterdevelopment-aiintegration-geminiapi-ugcPost-7271984981520904192-_aM1?utm_source=share&utm_medium=member_desktop&rcm=ACoAADrdZwgBeRZJui8GXBIdXTsTid0ZnVsQCT0",
    tags: ["FastAPI", "FAISS", "Gemini AI", "LangChain", "Flutter"]
  },
  {
    title: "CashierBot for Restaurants",
    description: "An AI-powered chatbot built with Rasa to streamline order placement, table reservations, and menu browsing using Natural Language Understanding.",
    imgUrl: "https://github.com/abdullah-khaled0/CashierBot-with-Rasa-open-source/raw/main/demo_gif.gif",
    linkUrl: "https://github.com/abdullah-khaled0/CashierBot-with-Rasa-open-source",
    tags: ["Rasa NLU", "Chatbot", "Python", "Conversational AI"]
  },
  {
    title: "AI Quiz Generator",
    description: "A FastAPI-based application that generates multiple-choice quizzes from the content of uploaded PDF files, leveraging FAISS and Gemini.",
    imgUrl: "https://github.com/abdullah-khaled0/Exam-Generator/raw/main/demo.gif",
    linkUrl: "https://www.linkedin.com/posts/doaa-safwat-794b72289_flutterdevelopment-aiintegration-aimodel-ugcPost-7282006280301334530-D-yL?utm_source=share&utm_medium=member_desktop&rcm=ACoAADrdZwgBeRZJui8GXBIdXTsTid0ZnVsQCT0",
    tags: ["FastAPI", "PDF Parsing", "FAISS", "Gemini", "Flutter"]
  },
  {
    title: "FCAI Academic App",
    description: "Created to assist FCAI classmates in their studies, designed and published on Google Play Store to simplify access to academic materials.",
    imgUrl: "https://github.com/abdullah0150/Images/blob/main/images/0114.gif?raw=true",
    linkUrl: "https://drive.google.com/file/d/1B7Xh2xrwt-4-3O88ULzaCfRKWy__Uolc/view?usp=drive_link&usp=embed_facebook",
    tags: ["Mobile App", "Education", "Google Play Store"]
  },
  {
    title: "Tasbeeh Digital Tool",
    description: "Developed and released a Tasbeeh app, providing users with a digital tool for tasbeeh.",
    imgUrl: "https://github.com/abdullah0150/Images/blob/main/images/tasbeeh.jpg?raw=true",
    linkUrl: "https://drive.google.com/file/d/1B7Xh2xrwt-4-3O88ULzaCfRKWy__Uolc/view?usp=drive_link&usp=embed_facebook",
    tags: ["Mobile App", "Utilities", "Flutter"]
  },
  {
    title: "3D Mobile Game",
    description: "Designed, developed, and published a 3D game on the Google Play Store using Unity Engine.",
    imgUrl: "https://github.com/abdullah0150/Images/blob/main/images/game.gif?raw=true",
    linkUrl: "https://drive.google.com/file/d/1B7Xh2xrwt-4-3O88ULzaCfRKWy__Uolc/view?usp=drive_link&usp=embed_facebook",
    tags: ["Unity", "Game Dev", "3D Graphics"]
  },
  {
    title: "Hoozgram Mood Tracker",
    description: "Built and launched this app to help users express and track their mood, fostering greater emotional awareness.",
    imgUrl: "https://github.com/abdullah0150/Images/blob/main/images/hoozgram.jpg?raw=true",
    linkUrl: "https://drive.google.com/file/d/1B7Xh2xrwt-4-3O88ULzaCfRKWy__Uolc/view?usp=drive_link&usp=embed_facebook",
    tags: ["Flutter", "Mood Tracker", "Mobile App"]
  }
];
